import { Component, effect, ElementRef, input, output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { faCircleQuestion, faTrash } from '@fortawesome/pro-regular-svg-icons';

import { ICustomTerm } from '../../../models/survey-editor/custom-terms.interface';

@Component({
  selector: 'empathy-terms-form-term-item',
  templateUrl: 'term-item.component.html',
  styleUrls: ['./term-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FlagsFormTermItemComponent {
  @ViewChild('termItemInput') termItemInput: ElementRef;

  allowDelete = input<boolean>(false);
  focus = input<boolean>(false);
  termGroup = input<FormGroup<ICustomTerm>>();
  selected = input<boolean>(false);

  add = output<void>();
  deleteTerm = output<void>();
  pasteTerms = output<string[]>();
  selectTerm = output<boolean>();

  readonly tooltip =
    `Choose how to match your custom term:\n
      Contains - Flags any response that includes this term as part of a longer word or sentence.\n
      Exact match - Flags only responses that exactly match this term, with no extra words or characters.
    `;

  faCircleQuestion = faCircleQuestion;
  faTrash = faTrash;

  constructor() {
    effect(() => {
      if (this.focus()) {
        this.termItemInput.nativeElement.focus();
      }
    });
  }

  onSetTermType(type: 'contains' | 'exact'): void {
    this.termGroup().get('type').setValue(type);
  }

  onPasteTerms(event: ClipboardEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (!navigator.clipboard) {
      return;
    }

    navigator.clipboard.readText().then((text) => {
      const terms = text.split(/[\s,;]+/).filter((term) => term.trim() !== '');
      this.pasteTerms.emit(terms);
    });
  }

  onDeleteTermTyping(event: Event): void {
    if (this.termGroup().get('term').value === '' && this.allowDelete()) {
      event.preventDefault();
      this.deleteTerm.emit();
    }
  }
}
